module.exports = __webpack_public_path__ + "img/supervisionBg.e7ad06f5.jpg";